module.exports = __webpack_public_path__ + "static/media/geesaa_8.64ed2ea5.jpg";